import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  PROGRESS_DIALOG_CANCEL_RESULT,
  ProgressDialogData,
} from './progress-dialog.data';

const DEFAULT_CANCEL_LABEL = 'Cancelar';

/**
 * ProgressDialogComponent
 *
 * Diálogo bloqueante para operaciones largas de duración desconocida: spinner
 * indeterminado, mensaje y una única salida explícita (Cancelar). Se abre con
 * `disableClose: true` para que ni el backdrop ni ESC lo cierren — mientras la
 * operación corre, la pantalla no acepta otra cosa, que es justamente lo que
 * evita el doble disparo.
 *
 * No sabe nada de qué operación está esperando: quien lo abre le pasa los
 * textos y decide qué hacer con el cierre.
 * @author daas software s.r.l <hola@daas.consulting>
 */
@Component({
  selector: 'daas-consulting-progress-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './progress-dialog.component.html',
  styleUrl: './progress-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressDialogComponent {
  readonly data: ProgressDialogData;
  readonly cancelLabel: string;
  readonly #dialogRef: MatDialogRef<ProgressDialogComponent, string>;

  constructor(
    dialogRef: MatDialogRef<ProgressDialogComponent, string>,
    @Inject(MAT_DIALOG_DATA) data: ProgressDialogData
  ) {
    this.#dialogRef = dialogRef;
    this.data = data;
    this.cancelLabel = data.cancelLabel ?? DEFAULT_CANCEL_LABEL;
  }

  handleCancel($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.#dialogRef.close(PROGRESS_DIALOG_CANCEL_RESULT);
  }
}
